import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    number: '1',
    text: 'Descargas el manual y seleccionas una de las 5 recetas de alta rotación según los ingredientes que ya tienes en tu alacena.'
  }, {
    number: '2',
    text: 'Aplicas la Hoja de Costo Real para fijar un precio que te deje ganancia neta después de pagar insumos, servicios y tu sueldo.'
  }, {
    number: '3',
    text: 'Sigues el protocolo de ventas por WhatsApp para lanzar tu primer lote y recuperar tu inversión en menos de 48 horas.'
  }];
  return <section className="py-20 px-6" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-44">
          ¿Cómo funciona?
        </motion.h2>

        <div className="space-y-8" data-id="element-45">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="flex flex-col md:flex-row items-start md:items-center gap-6 bg-white p-6 md:p-8 rounded-3xl shadow-warm relative" data-id="element-46">
              <div className="shrink-0 w-16 h-16 bg-amber text-white rounded-full flex items-center justify-center text-3xl font-serif font-bold shadow-warm" data-id="element-47">
                {step.number}
              </div>
              <p className="text-lg md:text-xl text-chocolate/90 leading-relaxed" data-id="element-48">
                {step.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}